import { inject, Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApolloService {
  private readonly apollo = inject(Apollo);

  query<T>(
    query: string,
    dataKey: string,
    variables?: any,
    clientName: string = 'default',
  ): Observable<T> {
    return this.apollo
      .use(clientName)
      .query<T>({
        query: gql`
          ${query}
        `,
        variables,
      })
      .pipe(map((x) => JSON.parse(JSON.stringify(x.data[dataKey]))));
  }

  mutate<T>(mutation: string, dataKey: string, variables?: any): Observable<T> {
    return this.apollo
      .mutate<T>({
        mutation: gql`mutation ${mutation}`,
        variables,
      })
      .pipe(map((x) => JSON.parse(JSON.stringify(x.data[dataKey]))));
  }
}
